import React, { Component } from 'react';

import { FluidSection } from '../../components/FluidSection/index'
import { Content } from '../../components/Content/index';
import { Hero } from '../../components/Hero/index';
import { List } from '../../components/List/index';

// UTILS
import { constants } from '../../constants/index';

class AboutCorporate extends Component {
  state = {
    listItems: [ 'Family Medicine', 'Physiotherapy', 'Personal training', 'Nutrition', 'Naturopath', 'Mental wellness' ]
  }

  render() {
    return (
      <div style={{...constants.layout.container, ...constants.text.baseFontStyles}}>
        <Hero 
          backgroundImageURL={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2FheroImage%2FCity-Buildings.jpg?alt=media&token=59f9afc2-639b-44de-ac15-26e28d41c1d2'} 
          mainTitleText="Cyno Corporate Program" 
          height={300} 
        />
          <FluidSection>
            <Content
               mainTitleText={"Create a healthier and happier workforce with Cyno"} 
              /> 
            </FluidSection>
            <FluidSection>
              <Content
                subTitleText={"Corporate Program"}
                style={{ 
                  marginBottom: 40, 
                  marginRight: 40, 
                  maxWidth: 500, 
                }}   
              >
                <p>Cyno offers virtual employee health that allows corporations to remove the barriers of time, access, and convenience in creating a healthier and happier workforce. The Cyno platform offers secure live video consultative services (with prescription) from some of Canada’s top healthcare providers in the areas of:</p>
                  
                <List 
                  faIcon={'fa fa-circle'}
                  iconSize={10}
                  style={{ marginLeft: 40 }} 
                  data={this.state.listItems} 
                />
                <p style={{marginTop:0}}>The corporation is empowered to put a dollar credit on each employee’s Cyno account and the employee can find the specific provider and services that will meet their health needs anytime anywhere. The corporation is only invoiced for credits that are redeemed by the employee.</p>

              </Content> 
              <Content
                backgroundImageURL={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2Fimg%2FofficeHands.jpg?alt=media&token=2c194ae2-c43c-4921-bbcb-07379988309a'}
                style={{ maxWidth: 350, minWidth: 200, height: 600 }}
              />
              
              
          </FluidSection>
      </div>
    ); 
  }
}

export default AboutCorporate;



// WEBPACK FOOTER //
// ./src/js/containers/AboutCorporate/AboutCorporate.jsx